export default {
  public: [
    {
      path: '/',
      name: 'home',
      component: () => import('modules/base/views/public/home.vue'),
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('modules/base/views/public/news.vue'),
    },
    {
      path: '/child',
      name: 'child',
      component: () => import('modules/base/views/public/child.vue'),
    },
    {
      path: '/drama',
      name: 'drama',
      meta: { code: 'drama' },
      component: () => import('modules/base/views/public/program/program.vue'),
    },
    {
      path: '/program',
      name: 'program',
      component: () => import('modules/base/views/public/program/program.vue'),
    },
    {
      path: '/workspace',
      name: 'workspace',
      component: () => import('modules/base/views/public/workspace.vue'),
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: () => import('modules/base/views/public/schedule.vue'),
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('modules/base/views/public/search.vue'),
    },
    {
      path: 'customer-service-read-by-code',
      name: 'customer-service-read-by-code',
      meta: {
        readByCode: true,
      },
      component: () => import('modules/member/views/member/customServiceDetail.vue'),
    },

    /**
     * type可用值(參考article constant的type)
     */
    {
      path: '/service/:type',
      name: 'service',
      component: () => import('modules/base/views/public/service.vue'),
      children: [
        // 文章
        {
          path: 'article/:id',
          name: 'article',
          component: () => import('modules/base/views/public/service/article.vue'),
        },

        // 營運治理 > 監督機制
        {
          path: 'oversee',
          name: 'oversee',
          component: () => import('modules/base/views/public/service/oversee/oversee.vue'),
        },
        // 營運治理 > 營運成果
        {
          path: 'operating-results',
          name: 'operating-results',
          component: () => import('modules/base/views/public/service/operatingResult/operatingResult.vue'),
        },
        // 營運治理 > 年度計畫
        {
          path: 'yearly-plan',
          name: 'yearly-plan',
          component: () => import('modules/base/views/public/service/yearlyPlan/yearlyPlan.vue'),
        },
        // 營運治理 > 入圍得獎
        {
          path: 'awards',
          name: 'awards',
          component: () => import('modules/base/views/public/service/awards.vue'),
        },
        // 營運治理 > 大事紀要
        {
          path: 'big-events',
          name: 'big-events',
          component: () => import('modules/base/views/public/service/bigEvents.vue'),
        },

        // 觀眾服務 > 線上客服
        {
          path: 'custom-service',
          name: 'custom-service',
          component: () => import('modules/base/views/public/service/customerService.vue'),
        },
        // 觀眾服務 > 節目申訴
        {
          path: 'appeal/reply',
          name: 'appeal-reply',
          component: () => import('modules/base/views/public/service/appeal/appeal.vue'),
        },

        {
          path: 'appeal/:id', // 查詢指定申訴內容
          name: 'appeal-detail',
          component: () => import('modules/base/views/public/service/appeal/appeal.vue'),
        },

        {
          path: 'appeal',
          name: 'appeal',
          component: () => import('modules/base/views/public/service/appeal/appeal.vue'),
        },

        // 觀眾服務 > 客臺參訪
        {
          path: 'visit',
          name: 'visit',
          component: () => import('modules/base/views/public/service/visit/visit.vue'),
        },

        // 觀眾服務 > 客家好物
        {
          path: 'hakka-goods',
          name: 'hakka-goods',
          component: () => import('modules/base/views/public/service/hakkaGoods.vue'),
        },

        // 觀眾服務 > 常用問題
        {
          path: 'faq',
          name: 'faq',
          component: () => import('modules/base/views/public/service/faq.vue'),
        },


        // 其他服務 > 客台徵才
        {
          path: 'hire',
          name: 'hire',
          component: () => import('modules/base/views/public/service/hire.vue'),
        },
        // 其他服務 > 學生實習
        {
          path: 'practice',
          name: 'practice',
          component: () => import('modules/base/views/public/service/practice.vue'),
        },

        // 其他服務 > 客臺徵案
        {
          path: 'project',
          name: 'project',
          component: () => import('modules/base/views/public/service/project/project.vue'),
        },
        // 其他服務 > 公益託播
        {
          path: 'welfare',
          name: 'welfare',
          component: () => import('modules/base/views/public/service/welfare.vue'),
        },
        // 其他服務 > 版權洽詢
        {
          path: 'copyright',
          name: 'copyright',
          component: () => import('modules/base/views/public/service/copyright.vue'),
        },
      ],
    },

    // 最新消息
    {
      path: 'post',
      name: 'post',
      component: () => import('modules/base/views/public/postList.vue'),
    },

    // 最新消息內頁
    {
      path: 'post/:id',
      name: 'post-detail',
      component: () => import('modules/base/views/public/postDetail.vue'),
    },
  ],
  admin: [
    {
      path: '',
      name: 'admin.home',
      component: () => import('modules/base/views/admin/home.vue'),
    },

    // 系統初始化導覽頁
    {
      path: 'initialize',
      name: 'admin.initialize',
      component: () => import('modules/base/views/admin/initialize/initialize.vue'),
      meta: {
        mode: 'update',
      },
    },

    // 網站設定
    {
      path: 'config/site',
      name: 'admin.config.site',
      component: () => import('modules/base/views/admin/siteConfigForm/siteConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

    // 網站設定
    {
      path: 'config/public-site',
      name: 'admin.config.public-site',
      component: () => import('modules/base/views/admin/publicSiteConfigForm/siteConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

    // 追蹤設定
    {
      path: 'config/tracker',
      name: 'admin.config.tracker',
      component: () => import('modules/base/views/admin/trackerConfigForm/trackerConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

    // 追蹤設定
    {
      path: 'config/major-notification',
      name: 'admin.config.major_notification',
      component: () => import('modules/base/views/admin/majorNotificationConfigForm/majorNotificationConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

    // 網站地圖
    {
      path: 'config/sitemap-file',
      name: 'admin.config.sitemap',
      component: () => import('modules/base/views/admin/sitemap/sitemap.vue'),
      meta: {
        mode: 'update',
      },
    },

    // oauth設定
    {
      path: 'config/oauth',
      name: 'admin.config.oauth',
      component: () => import('modules/base/views/admin/oauthConfigForm/oauthConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

    // 其他設定
    {
      path: 'config/etc',
      name: 'admin.config.etc',
      component: () => import('modules/base/views/admin/etcConfigForm/etcConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

    // 語系設定
    {
      path: 'config/language',
      name: 'admin.config.language',
      component: () => import('modules/base/views/admin/languageConfig/languageConfig.vue'),
    },


    {
      path: 'open-data/:category',
      name: 'admin.open-data-list',
      component: () => import('modules/base/views/admin/openDataList/openDataList.vue'),
    },
    {
      path: 'open-data/:category/update/:id',
      name: 'admin.open-data-update',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/base/views/admin/openData/openDataForm.vue'),
    },

    {
      path: 'report/member/:scope',
      name: 'admin.report.member',
      component: () => import('modules/base/views/admin/report/member.vue'),
    },
    {
      path: 'report/memberGA4/:scope',
      name: 'admin.report.memberGA4',
      component: () => import('modules/base/views/admin/report/memberGA4.vue'),
    },

    {
      path: 'report/pageview/:scope',
      name: 'admin.report.pageview',
      component: () => import('modules/base/views/admin/report/pageview.vue'),
    },

    {
      path: 'report/pageviewGA4/:scope',
      name: 'admin.report.pageviewGA4',
      component: () => import('modules/base/views/admin/report/pageviewGA4.vue'),
    },

    {
      path: 'report/keywords/:scope',
      name: 'admin.report.keywords',
      component: () => import('modules/base/views/admin/report/keywords.vue'),
    },

    {
      path: 'report/keywordsGA4/:scope',
      name: 'admin.report.keywordsGA4',
      component: () => import('modules/base/views/admin/report/keywordsGA4.vue'),
    },

    {
      path: 'report/video/:scope',
      name: 'admin.report.video',
      component: () => import('modules/base/views/admin/report/video.vue'),
    },

    {
      path: 'report/videoGA4/:scope',
      name: 'admin.report.videoGA4',
      component: () => import('modules/base/views/admin/report/videoGA4.vue'),
    },

    {
      path: 'report/member-trend',
      name: 'admin.report.member-trend',
      component: () => import('modules/base/views/admin/report/memberTrend.vue'),
    },

    {
      path: 'report/audience',
      name: 'admin.report.audience',
      component: () => import('modules/base/views/admin/report/audience.vue'),
    },

    // 表單說明設定
    {
      path: 'config/custom-html-content',
      name: 'admin.config.custom-html-content',
      component: () => import('modules/base/views/admin/customHtmlContentConfigForm/customHtmlContentConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

    // 表單說明設定
    {
      path: 'config/customer-service-etc-config',
      name: 'admin.config.customer-service-etc-config',
      component: () => import('modules/base/views/admin/customerServiceEtcConfigForm/customerServiceEtcConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

  ],
}